import { render, staticRenderFns } from "./NotificationComment.vue?vue&type=template&id=169fc243&scoped=true&lang=pug&"
import script from "./NotificationComment.vue?vue&type=script&lang=js&"
export * from "./NotificationComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169fc243",
  null
  
)

export default component.exports